import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Popover } from '../../../../../../global/popover/popover';
import { EditableArea } from '../../../../../../global/editable-area/editable-area';
import { MEDIUM_PLAIN_TEXT_LENGTH } from '../../../../../../../constants/common.constants';
import { EditIcon } from '../../../../../../global/icons/icons';

import './_attendee-notes.scss';
import Text from '../../../../../../global/text/text';


interface IProps {
    note: string;
    handleChangeMeetingNote: (newNote: string) => void;
}

const AttendeeNotes = (props: IProps) => {
    const {note, handleChangeMeetingNote} = props;

    const [isModalOpen, setModalOpen] = useState(false);
    const buttonRef = useRef(null);

    const attendeeNoteValidator = (content: string) => {
        if (content.length > MEDIUM_PLAIN_TEXT_LENGTH) {
            return <>
                <FormattedMessage
                    id='oe.attendee.attendeeNoteTooLong'
                    defaultMessage='The attendee note is too long.'
                    description='Error label text'
                />
                <FormattedMessage
                    id='oe.attendee.MaxLengthIs'
                    defaultMessage='Max length is {length} characters'
                    description='Error label text'
                    values={{
                        length: MEDIUM_PLAIN_TEXT_LENGTH
                    }}
                />
            </>;
        }
        return null;
    };
    return (
        <div
            className={classnames('status-button attendee-notes-section', {
                'status-button--active': isModalOpen,
            })}
            ref={buttonRef}
        >
            <div className={classnames('status-button__wrapper', {
                'status-button__wrapper--active': isModalOpen || note.length
            })} onClick={() => setModalOpen(prevState => !prevState)}>
                <Text
                    className='status-button__wrapper__preview'
                    id={!note && 'oe.note.addNote'}
                    message={note || 'Add note'}
                    description='label text'
                    withEllipsis
                />
                <EditIcon className={classnames('attendee-notes-section__icon', {
                    'attendee-notes-section__icon--hidden': note.length,
                    'attendee-notes-section__icon--visible': isModalOpen
                })}/>
            </div>
            <Popover
                padding={0}
                isOpen={isModalOpen}
                buttonRef={buttonRef}
                customWidth={buttonRef.current?.getBoundingClientRect().width}
            >
                <div className='status-button__content'>
                    <div className='status-button__content-label'>
                        <FormattedMessage
                            id='oe.attendee.note'
                            defaultMessage='Attendee Note'
                            description='Label text'
                            values={{
                                length: MEDIUM_PLAIN_TEXT_LENGTH
                            }}
                        />
                    </div>
                    <EditableArea
                        content={note}
                        onSave={value => handleChangeMeetingNote(value)}
                        validator={attendeeNoteValidator}
                        onBlur={() => setModalOpen(false)}
                        shouldSaveOnBlur
                    />
                </div>
            </Popover>
        </div>
    );
};

export default AttendeeNotes;